<template>
  <div>
    <SkinnyBanner page="landing" />
    <Breadcrumb :id="id" />
    <!-- TODO: Ratings or rates is somewhere, see https://github.com/BackMarket/front-apps/pull/1548#discussion_r1502880349 to find it out! -->
    <TrustList class="mb-32" spot="landing" />
    <RevContainer data-spec="body">
      <div data-spec="main">
        <section data-test="product-results-refinement">
          <div class="mb-12 justify-between lg:mb-32 lg:flex">
            <div>
              <h1 class="heading-1">{{ title }}</h1>
              <span class="body-2">{{ tagline }}</span>
            </div>

            <RevInputSelect
              id="sort"
              v-model="sortValue"
              class="hidden basis-200 lg:block"
              data-qa="sort-by-desktop"
              :label="i18n(translations.sort)"
              :options="sortOptions"
            />
          </div>

          <div class="lg:flex lg:gap-16">
            <div>
              <SideNavigation class="mb-32" :page-id="id" />
              <div class="hidden lg:block lg:w-256" data-test="filters-wrapper">
                <ul>
                  <li>
                    <PriceFilter
                      :avgPrice="{ amount: '99', currency: 'EUR' }"
                      :currency="Currency.EUR"
                      :maxRange="100"
                      :range="50"
                      :value="{ min: 0, max: 100 }"
                      :values="[12, 50, 69, 123]"
                    />
                  </li>
                  <li
                    v-for="item in [
                      { name: 'foo' },
                      { name: 'bar' },
                      { name: 'baz' },
                    ]"
                    :key="item.name"
                    class="mt-32"
                  >
                    <PlaceholderComponent
                      :name="`FacetsFilter: ${item.name}`"
                    />
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <ActiveFilters
                class="mb-8 md:mb-32"
                :facets="[
                  {
                    facetName: 'category',
                    facetValues: [
                      { label: 'Foo', facet_value: 'foo', count: 3 },
                      { label: 'Bar', facet_value: 'bar', count: 5 },
                    ],
                    name: 'Category',
                    title: 'Category',
                    type: 'checkbox',
                  },
                ]"
                :filters="{
                  category: ['foo', 'bar'],
                  brand: ['Apple', 'Dell'],
                }"
                :search-nb-results="42"
              />
              <div
                class="mb-20 grid grid-cols-1 gap-16 md:grid-cols-2 lg:grid-cols-3"
              >
                <HighlightedProductCard
                  class="md:col-span-2"
                  :color-swatches="[
                    { name: 'red', value: 'red' },
                    { name: 'green', value: 'green' },
                  ]"
                  :description="'Amazing product'"
                  :image-alt="'Amazing image'"
                  :image-src="'https://www.backmarket.com/cdn-cgi/image/format%3Dauto%2Cquality%3D75%2Cwidth%3D3840/https://d2e6ccujb3mkqf.cloudfront.net/5caea418-e82d-412e-8317-d7169502aec5-1_d828f51b-728e-49d0-8b02-e089288aca0d.jpg'"
                  :percentage-difference="23"
                  :price="{ amount: '12', currency: 'EUR' }"
                  :review-rating="{ count: 1200, average: 4.5 }"
                  :storage-tags="[{ name: 'foo', value: 'foo' }]"
                  :title="'Amazing product'"
                  :url="'#'"
                  :warranty="'12 mois'"
                />
                <ProductCard
                  v-for="index in Array(21)"
                  :key="index"
                  :color-swatches="[
                    { name: 'red', value: 'red' },
                    { name: 'green', value: 'green' },
                  ]"
                  :description="'Amazing product'"
                  :grade="'foo'"
                  :image-alt="'Amazing image'"
                  :image-src="'https://www.backmarket.com/cdn-cgi/image/format%3Dauto%2Cquality%3D75%2Cwidth%3D3840/https://d2e6ccujb3mkqf.cloudfront.net/5caea418-e82d-412e-8317-d7169502aec5-1_d828f51b-728e-49d0-8b02-e089288aca0d.jpg'"
                  :listing-id="'12345'"
                  :price="{ amount: '12', currency: 'EUR' }"
                  :title="'Amazing product'"
                  :url="'#'"
                />
              </div>
            </div>
          </div>

          <Pagination :page-count="pageCount" />
        </section>

        <PlaceholderComponent name="Reviews" />
        <PlaceholderComponent name="Guides" />
        <PlaceholderComponent name="ProductTags" />
        <PlaceholderComponent name="SEOText" />
      </div>
    </RevContainer>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import { Currency } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevInputSelect } from '@ds/components/InputSelect'
import { useRoute } from 'nuxt/app'

import SkinnyBanner from '~/scopes/branding/components/SkinnyBanner/SkinnyBanner.vue'
import TrustList from '~/scopes/reassurance/components/TrustList/TrustList.vue'
import ProductCard from '~/scopes/recommendation/components/ProductCard.vue'

import ActiveFilters from '../components/ActiveFilters/ActiveFilters.vue'
import Breadcrumb from '../components/Breadcrumb.vue'
import HighlightedProductCard from '../components/HighlightedProductCard.vue'
import Pagination from '../components/Pagination.vue'
import PlaceholderComponent from '../components/PlaceholderComponent.vue'
import PriceFilter from '../components/Refinements/components/PriceFilter/PriceFilter.vue'
import SideNavigation from '../components/SideNavigation.vue'
import { useProductListPage } from '../composables/useProductListPage'

import translations from './ProductListPage.translations'

const sortOptions = [
  'Meilleures ventes',
  'Prix : du plus bas au plus élevé',
  'Prix décroissant',
]
const sortValue = ref(sortOptions[0])
const i18n = useI18n()
const route = useRoute()
const id = Array.isArray(route.params.uuid)
  ? route.params.uuid[0]
  : route.params.uuid

const { title, tagline } = useProductListPage(id)
const pageCount = ref(25)
</script>
